import FaqComponentView from "../faq/faqComponentView";
import MainCTA from "../CTA-sections/mainCTA";
import {setupFAQs} from "../../static-data/allFAQs";
import {Image3} from "../../assets";

export default function TechnicalSEOExplainerComponent(props){

    function imageComponent(imageSrc, alt) {
        return (
            <div className="flex justify-center">
                <img
                    className="rounded w-2/3"
                    src={imageSrc}
                    alt={alt ? alt : "HerStory SEO Services for online retailers"}/>
            </div>
        )
    }

    return (
        <div>
            <main>
                <section className="container container-wide container-single">
                    <section id="extended-text" className="ns-bio-hero alignfull">
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content">
                                <h1 className="p1"><div className="text-5xl sm:text-7xl">Understanding Technical SEO</div></h1>
                                <p className="p1" style={{'fontSize': '20px'}}>
                                    <strong>TL;DR:</strong> Technical SEO is all about making sure your website is 'search
                                    engine-friendly' behind the scenes.
                                    This involves ensuring your website's structure and code are easily understood by
                                    search engines. A
                                    strong understanding of website architecture, code, and schema markup is crucial for
                                    successful technical SEO.
                                </p>
                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img decoding="async"
                                     src={Image3}
                                     alt="A New Way Forward For Technical SEO"/>
                            </figure>
                        </div>
                    </section>
                    <h1 className="wp-block-heading text-2xl sm:text-6xl">
                        <strong>KEY FIRST STEP: CRAWLING</strong>
                    </h1>
                    <p>
                        We can crawl and fix, or only crawl.
                        To ensure your website's visibility and performance, it's essential to monitor
                        your SEO metrics and submit your pages to search engines. By setting up&nbsp;
                        <a href="https://search.google.com/search-console/welcome" target="_blank">Google Search Console
                            (GSC)</a>, a free tool, you can effectively oversee, maintain, and
                        troubleshoot your site's performance in Google search results. GSC stands as one of
                        the premier tools for understanding how Google perceives your website. &nbsp;
                    </p>
                    {imageComponent("https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/SEO%2FScreenshot%202024-12-25%20at%205.05.24%E2%80%AFPM.png?alt=media&token=59bb600a-5a3c-41d8-bca8-396430b9cf0e")}
                    <p>
                        Once you've created your account, you'll be able to:
                        <li>Measure the traffic you get from Google and which keywords bring the most traffic</li>
                        <li>Understand your average engagement rate, and time spent on your site</li>
                        <li>Identify the pages on your site that bring the most traffic</li>
                        <li>See your Core Web Vitals scores</li>
                        <li>Submit your sitemap</li>
                        <li>Fix website errors</li>
                    </p>

                    <p>
                        {imageComponent("https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/SEO%2FGoogle-search-console.png?alt=media&token=5a8cb801-3499-4e2e-9973-1a0c21279e5c")}
                        <div>
                            <strong>TIP:</strong> As part of your SEO efforts, focus on keyword research, on-page
                            optimization, and high quality
                            content creation. These strategies will help you attract more visitors and improve your
                            site's
                            visibility in search engine results. Additionally, leveraging tools like Google Search
                            Console
                            and Bing Webmaster Tools will enable you to monitor your site's performance and make
                            necessary
                            adjustments.
                        </div>
                    </p>


                    <h1 className="wp-block-heading text-2xl sm:text-6xl">
                        <strong>OPTIMIZE WEBSITE</strong>&nbsp;&nbsp;</h1>
                    <p>
                        Next step, set up&nbsp;<a
                        href="https://www.bing.com/webmaster/contentremovalform/showanonymouspage"
                        target="_blank">Bing Webmaster Tools (BWT)</a>. While the Bing search
                        engine is not as popular as Google,
                        it earns over 100 million daily active users, making it a valuable platform to optimize for.
                        In the world of SEO, data is paramount. Utilizing BWT can provide you with additional useful
                        data, making it a great choice to enhance your website's performance. This tool allows you to
                        submit your pages for indexing, see what users are searching for, identify crawl errors, and
                        more.
                    </p>
                    {imageComponent("https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/SEO%2Fbing-webmaster-tools-performance.png?alt=media&token=8accf535-25ba-46f8-b58d-d277b3c3477c")}
                    <div>
                        <strong>TIP:</strong>&nbsp;Keep an eye out for special offers. Bing frequently provides ad
                        credits to promote their search engine.
                    </div>


                    <h1 className="wp-block-heading text-2xl sm:text-6xl">
                        <strong>FINAL STEP: SET UP GOOGLE ANALYTICS</strong>&nbsp;&nbsp;</h1>
                    <p>
                        Google Analytics is user-oriented, providing data related to
                        those who visit and interact with your website.

                        Google Search Console, on the other hand, is search-engine focused,
                        providing tools and insights that can help site owners improve
                        visibility and presence in the SERPs
                    </p>
                    {imageComponent("https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/SEO%2Fga-vs-gs.webp?alt=media&token=654dbf2d-e56d-42d8-889e-d4a44a3c7287")}
                    <div>
                        <strong>TIP:</strong>&nbsp;Keep an eye out for special offers. Bing frequently provides ad
                        credits to promote their search engine.
                    </div>
                    <br/>

                    <div className="my-12 mb-24">
                        <MainCTA/>
                    </div>

                    <h3 className="custom-font font-semibold">Frequently Asked Questions</h3>
                    <FaqComponentView faqData={setupFAQs}/>

                </section>
            </main>
        </div>
    )
}